import React from 'react';
import { DataListEmptyProps } from './types';
import { HiOutlineDocumentMagnifyingGlass } from 'react-icons/hi2';

/**
 * DataListEmpty - Cadence Pro styled empty state
 * Clean, minimal design with brand colors
 */
const DataListEmpty: React.FC<DataListEmptyProps> = ({
    message = 'No results found',
}) => {
    return (
        <tr>
            <td colSpan={100} className="py-20 px-4 text-center">
                <div className="flex flex-col items-center justify-center w-full  h-[200px] gap-2">
                    <div className="w-14 h-14 rounded-xl bg-tertiary-light dark:bg-hover-dark  flex justify-center items-center shadow-sm">
                        <HiOutlineDocumentMagnifyingGlass className="w-7 h-7 text-primary-light dark:text-primary-dark" />
                    </div>
                    <p className="text-light-text-primary dark:text-gray-200 text-sm font-medium">
                        {message}
                    </p>
                    <p className="text-light-text-muted dark:text-gray-500 text-xs mt-1.5 max-w-xs">
                        Try adjusting your filters or search criteria
                    </p>
                </div>
            </td>
        </tr>
    );
};

export default DataListEmpty;
